export const RegionComparativeSalesPerf = {
    "sections": [
      {
        "columns": 4,
        "rows": 1,
        "visual": {
          "id": 14,
          "type": "summary",
          "colorTheme": "colorTheme1",
          "title": "Sales Performance Summary",
          "binding": {
            "data": {
              "title": '',
              "value": '',
              "displayTarget": true,
              "endpoint": "N62",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "RegionCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 8,
        "rows": 1,
        "visual": {
          "id": 4,
          "type": "treemap",
          "colorTheme": "colorTheme1",
          "title": "Share by District",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "title": 'DistrictGroupCode',
              "value": 'Share',
              "tooltip": 'ActualSales',
              "currency": true,
              "percent": true,
              "endpoint": "N31",
              "filter": {
                "show": false,
                "local": ["DistrictGroupCode"],
              },
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "DistrictGroupCode", "value": '' },
                { "key": "RegionCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "DistrictGroupCode",
                  "selectedTitle": "District Manager",
                  "visual": [
                    {
                      "columns": 12,
                      "rows": 2,
                      "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": 'colorTheme1',
                        "title": "District Manager",
                        "binding": {
                          "data": {
                            "columns": [
                              {
                                "name": 'District Manager Name',
                                "columnName": 'DistrictManagerName',
                                "width": '200px',
                                "align": "left",
                                "sortable": true,
                                "sum": false,
                              },
                              {
                                "name": 'Actual Sales',
                                "columnName": 'ActualSales',
                                "width": '140px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                              },
                              {
                                "name": 'LY Sales',
                                "columnName": 'LYSales',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                              },
                              {
                                "name": 'Growth %',
                                "columnName": 'Growth',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                              },
                              {
                                "name": 'Target',
                                "columnName": 'TargetSales',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                              },
                              {
                                "name": 'Performance %',
                                "columnName": 'Performance',
                                "width": '150px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                              }
                            ],
                            "title": "DistrictManagerName",
                            "endpoint": "N31.1",
                            "parameters": [
                              { "key": "FromMonth", "value": "2024" },
                              { "key": "FromYear", "value": "1" },
                              { "key": "ToMonth", "value": "2024" },
                              { "key": "ToYear", "value": "1" },
                              { "key": "DistrictGroupCode", "value": "" },
                              { "key": "ConfigTypeCode", "value": "" },
                              { "key": "RegionCode", "value": "" }
                            ]
                          },
                          "context": {
                            "point": {
                              "onClick": {
                                "selectedValueColumn": "DistrictGroupCodeDistrictManagerName",
                                "selectedTitle": "PMR",
                                "visuals": [
                                  {
                                    "title": "PMR",
                                    "visual": [
                                      {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                          "id": 1,
                                          "type": "advancedTable",
                                          "colorTheme": 'colorTheme1',
                                          "title": "PMR",
                                          "binding": {
                                            "data": {
                                              "columns": [
                                                {
                                                  "name": 'PMR Code',
                                                  "columnName": 'AgentCode',
                                                  "width": '150px',
                                                  "align": "left",
                                                  "sortable": true,
                                                  "sum": false,
                                                },
                                                {
                                                  "name": 'Employee Code',
                                                  "columnName": 'EmployeeCode',
                                                  "width": '160px',
                                                  "align": "left",
                                                  "sortable": true,
                                                  "sum": false,
                                                },
                                                {
                                                  "name": 'PMR Name',
                                                  "columnName": 'AgentName',
                                                  "width": '200px',
                                                  "align": "left",
                                                  "sortable": true,
                                                  "sum": false,
                                                },
                                                {
                                                  "name": 'Actual Sales',
                                                  "columnName": 'ActualSales',
                                                  "width": '140px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true,
                                                },
                                                {
                                                  "name": 'LY Sales',
                                                  "columnName": 'LYSales',
                                                  "width": '125px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true,
                                                },
                                                {
                                                  "name": 'Growth %',
                                                  "columnName": 'Growth',
                                                  "width": '125px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": false,
                                                  "percent": true
                                                },
                                                {
                                                  "name": 'Target',
                                                  "columnName": 'TargetSales',
                                                  "width": '125px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true,
                                                },
                                                {
                                                  "name": 'Performance %',
                                                  "columnName": 'Performance',
                                                  "width": '150px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": false,
                                                  "percent": true
                                                }
                                              ],
                                              "title": "AgentName",
                                              "endpoint": "N31.2",
                                              "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "DistrictGroupCodeDistrictManagerName", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" },
                                                { "key": "RegionCode", "value": "" }
                                              ]
                                            },
                                            "context": {
                                              "point": {
                                                "onClick": {
  
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "title": "Product Group",
                                    "visual": [
                                      {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                          "id": 1,
                                          "type": "advancedTable",
                                          "colorTheme": 'colorTheme1',
                                          "title": "Product Group",
                                          "binding": {
                                            "data": {
                                              "columns": [
                                                {
                                                  "name": 'Product Group',
                                                  "columnName": 'ItemDivisionCode',
                                                  "width": '200px',
                                                  "align": "left",
                                                  "sortable": true,
                                                  "sum": false,
                                                },
                                                {
                                                  "name": 'Actual Sales',
                                                  "columnName": 'ActualSales',
                                                  "width": '140px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true,
                                                },
                                                {
                                                  "name": 'LY Sales',
                                                  "columnName": 'LYSales',
                                                  "width": '125px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true,
                                                },
                                                {
                                                  "name": 'Growth %',
                                                  "columnName": 'Growth',
                                                  "width": '125px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": false,
                                                  "percent": true
                                                },
                                                {
                                                  "name": 'Target',
                                                  "columnName": 'TargetSales',
                                                  "width": '125px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": true,
                                                },
                                                {
                                                  "name": 'Performance %',
                                                  "columnName": 'Performance',
                                                  "width": '150px',
                                                  "align": "right",
                                                  "sortable": true,
                                                  "sum": false,
                                                  "percent": true
                                                }
                                              ],
                                              "title": "ItemDivisionCode",
                                              "endpoint": "N31.3",
                                              "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "DistrictGroupCodeDistrictManagerName", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" },
                                                { "key": "RegionCode", "value": "" }
                                              ]
                                            },
                                            "context": {
                                              "point": {
                                                "onClick": {
  
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    ]
                                  }
                                ]
                              }
                            }
                          }
                        }
                      }
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 1,
        "visual": {
          "id": 1,
          "type": "combo",
          "colorTheme": 'colorTheme1',
          "title": "Actual vs Target (% Performance)",
          "orientation": "vertical",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
                {
                  "name": 'Sales',
                  "value": 'Sales',
                  "type": 'column'
                },
                {
                  "name": 'Target',
                  "value": 'Target',
                  "type": 'column'
                },
                {
                  "name": 'Performance %',
                  "value": 'Performance',
                  "type": 'line',
                  "percent": true
                }
              ],
              "title": "Month",
              "endpoint": "N34",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "RegionCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 1,
        "visual": {
          "id": 1,
          "type": "combo",
          "colorTheme": 'colorTheme1',
          "title": "Actual Sales vs Last Year (% Growth)",
          "orientation": "vertical",
          "xAxis": "",
          "yAxis": "",
          "binding": {
            "data": {
              "series": [
  
                {
                  "name": 'Sales',
                  "value": 'ActualSales',
                  "type": 'column'
                },
                {
                  "name": 'LY Sales',
                  "value": 'LYSales',
                  "type": 'column'
                },
                {
                  "name": 'Growth %',
                  "value": 'Growth',
                  "type": 'line',
                  "percent": true
                }
              ],
              "title": "Month",
              "endpoint": "N33",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "RegionCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": 'colorTheme1',
          "title": "Employee Comparative Sales",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Employee Code',
                  "columnName": 'EmployeeCode',
                  "width": '160px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Employee Name',
                  "columnName": 'AgentName',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Jan',
                  "columnName": 'Jan',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Feb',
                  "columnName": 'Feb',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Mar',
                  "columnName": 'Mar',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Apr',
                  "columnName": 'Apr',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'May',
                  "columnName": 'May',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Jun',
                  "columnName": 'Jun',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Jul',
                  "columnName": 'Jul',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Aug',
                  "columnName": 'Aug',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Sep',
                  "columnName": 'Sep',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Oct',
                  "columnName": 'Oct',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Nov',
                  "columnName": 'Nov',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Dec',
                  "columnName": 'Dec',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Total Sales',
                  "columnName": 'TotalSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                }
              ],
              "title": "DistrictManagerName",
              "endpoint": "N68.4",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "RegionCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": 'colorTheme1',
          "title": "Employee Growth and Performance",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Employee Code',
                  "columnName": 'EmployeeCode',
                  "width": '160px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Employee Name',
                  "columnName": 'AgentName',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Actual Sales',
                  "columnName": 'ActualSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true,
                },
                {
                  "name": 'LY Sales',
                  "columnName": 'LYSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true,
                },
                {
                  "name": 'Growth %',
                  "columnName": 'Growth',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                },
                {
                  "name": 'Target',
                  "columnName": 'TargetSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true,
                },
                {
                  "name": 'Performance %',
                  "columnName": 'Performance',
                  "width": '150px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                }
              ],
              "title": "DistrictManagerName",
              "endpoint": "N68.5",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "ConfigTypeCode", "value": "" },
                { "key": "RegionCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                }
              }
            }
          }
        }
      }
    ]
  }